import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMute = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 26,
	viewBox: "0 0 24 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0563 18.5946C18.6421 18.8367 18.1185 18.682 17.8868 18.2489C17.6552 17.8158 17.8032 17.2684 18.2174 17.0262C19.3874 16.3422 20.127 15.052 20.127 13.6254C20.127 12.2092 19.3984 10.9271 18.242 10.239C17.8295 9.9935 17.6855 9.44494 17.9203 9.01371C18.1551 8.58249 18.6798 8.4319 19.0923 8.67736C20.7803 9.68189 21.8458 11.5568 21.8458 13.6254C21.8458 15.7094 20.7643 17.596 19.0563 18.5946Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.38346 18.4169L4.49653 17.6042C3.42535 17.3802 2.6543 16.3969 2.6543 15.2549V11.9956C2.6543 10.8535 3.42535 9.87026 4.49653 9.64628L8.38346 8.83356L12.1566 4.88895C12.604 4.42113 13.3295 4.42113 13.777 4.88895C13.9919 5.1136 14.1126 5.4183 14.1126 5.736V21.5145C14.1126 22.176 13.5996 22.7124 12.9668 22.7124C12.6629 22.7124 12.3715 22.5862 12.1566 22.3615L8.38346 18.4169Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 1.41134,
			y1: 1.09009,
			x2: 22.0901,
			y2: 24.5887,
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgMute;
